import React from "react";
import "./RenewableEnergySection.css";
import energy from "../../assets/energy.png";
import global from "../../assets/global.png";
import commercial from "../../assets/commercial.png";
import home from "../../assets/home.png";
import solaricon from "../../assets/solar-icon.png";
import Aboutbutton from "../../assets/Aboutbutton.png";
import { Link } from "react-router-dom";


const RenewableEnergySection = () => {
  return (
    <section className="renew-section">
      
      {/* Right Badge Box */}
      <div className="renew-badge">
  <div className="renew-badge-top">
    <p>Since 2019, our happy customers have avoided.</p>
  </div>

  <div className="renew-badge-line"></div>

  <div className="renew-badge-bottom">
    <img src={solaricon} alt="Solar Icon" className="badge-icon" />
    <p className="renew-badge-title">150 MW Solar Power Plant</p>
  </div>
</div>

      {/* Content */}
      <div className="renew-content">
        <p className="renew-breadcrumb">ABOUT › CW GROUP OF COMPANIES ENERGY</p>

        <h2 className="renew-heading">
          We are the top renewable <br /> energy solutions.
        </h2>

        <p className="renew-text">
          We are proud to announce the successful installation and commissioning
          of a 150 MW Solar Power Plant, a milestone step towards India's
          transition to sustainable energy. This landmark installation marks our
          commitment to powering India’s future. We deliver high-performance,
          scalable solar systems that maximize energy outputs and environmental
          benefits for homes, businesses, and industrial applications. Join the
          movement to energy independence and let solar help you contribute to a
          greener tomorrow.
        </p>

        {/* Features */}
<div className="renew-grid">

  <div className="renew-card">
    <img src={energy} alt="Energy Icon" />
    <h4>Renewable Energy</h4>
    <p>
      Delivering sustainable solar energy solutions that maximize efficiency,
      reduce carbon emissions, and create long-term value.
    </p>
  </div>

  <div className="renew-card">
    <img src={global} alt="Global Icon" />
    <h4>Proven Experience</h4>
    <p>
      With successful utility-scale projects and expert execution, we ensure
      dependable renewable energy systems for every client.
    </p>
  </div>

  <div className="renew-card">
    <img src={commercial} alt="Commercial Icon" />
    <h4>Business Solutions</h4>
    <p>
      Customized solar infrastructure for commercial and industrial facilities,
      helping organizations achieve greater energy efficiency.
    </p>
  </div>

  <div className="renew-card">
    <img src={home} alt="Home Icon" />
    <h4>Smart Home Solar</h4>
    <p>
      Modern rooftop solar systems designed to provide clean, reliable, and
      cost-effective power for residential properties.
    </p>
  </div>

</div>

        <Link to="/contact" className="renew-btn">
  <img src={Aboutbutton} alt="icon" className="renew-btn-icon" />
  Discover independence through the power of solar. <b>Explore our plans</b>
</Link>
      </div>
    </section>
  );
};

export default RenewableEnergySection;
